import { createFileRoute } from '@tanstack/react-router';

import { ToolFrame } from '../app/tool-frame.js';
import { N2000Section } from '../features/projects/detail/n2000/n2000-section.js';

export const Route = createFileRoute('/_authed/teams/$teamId/projects/$projectId/n2000')({
  component: () => <ToolFrame toolSlug="n2000" Section={N2000Section} requiresReport />,
});
